module.exports = __webpack_public_path__ + "img/collection-fff.9fec4661.svg";